// extracted by mini-css-extract-plugin
export default {"container":"whdM4Ypo1qsopjiPqAaH","toggleButton":"TSDrZ6kLLT5I7fWEYnm_","label":"dosTqSDRH8f_MUlKsonZ"};